import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
    name: 'imgsrc',
    pure: true,
    standalone: false
})
export class ImgSrcPipe implements PipeTransform {
  constructor() {}
  transform(code: string): string {
    // console.log('imgapi: ', code);
    return `${environment.apiUrl}/api/psp/content/getimage/${code}`;
  }
}
